// src/components/ReportSVG.js
import React from "react";
import { motion } from "framer-motion";

const svgVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.2 },
  },
};

const barVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const lineVariants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: {
    pathLength: 1,
    opacity: 1,
    transition: { duration: 1.5, ease: "easeInOut" },
  },
};

export default function ReportSVG({ gradientId }) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      variants={svgVariants}
      initial="hidden"
      animate="visible"
    >
      {/* 바 차트 */}
      <motion.rect x="15" y="60" width="15" height="25" rx="2" variants={barVariants} fill={`url(#${gradientId})`} />
      <motion.rect x="42.5" y="40" width="15" height="45" rx="2" variants={barVariants} fill={`url(#${gradientId})`} />
      <motion.rect x="70" y="20" width="15" height="65" rx="2" variants={barVariants} fill={`url(#${gradientId})`} />
      
      {/* 꺾은선 그래프 */}
      <motion.path
        d="M10 90 C 30 70, 40 30, 60 50 S 80 15, 90 20"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeOpacity={0.6}
        strokeWidth="5"
        strokeLinecap="round"
        variants={lineVariants}
      />
    </motion.svg>
  );
}